export const isValidRecipeNote = (elem: TContent): boolean =>
  !!elem.children.at(0)?.children.at(0)?.children.at(0);
